import { Stack, Typography } from "@mui/material"
import { Frame } from "../../components/layouts/Frame"
import { DataTable } from "../../components/global/Table/DataTable"
import { DataTableHeadCellData } from "../../components/global/Table/DataTableHeader";
import { UploadTagPanel } from "./UploadTagPanel";
import { useEffect, useRef, useState } from "react";
import { useAPI } from "../../hooks/useAPI";
import { useAuth } from "../../assets/contexts/AuthContext";
import { TagUploadData } from "../../types";

const headCells: DataTableHeadCellData[] = [
  {
    id: 'filename',
    disablePadding: true,
    label: 'Filename',
    align: 'left',
    sortable: true,
  },
  {
    id: 'date_imported',
    disablePadding: false,
    label: 'Date Imported',
  },
  {
    id: 'import_status',
    disablePadding: false,
    label: 'Import Status',
  },
];

interface TagUploadTableData {
  id: any;
  filename: JSX.Element;
  date_imported: any;
  import_status: JSX.Element;
}

export const UploadTags = () => {
  const isLoading = useRef(false);
  const [sIsLoading, setSIsLoading] = useState(false);
  const { fetchData } = useAPI();
  const [rows, setRows] = useState<TagUploadTableData[]>([]);
  const [tagUploads, setTagUploads] = useState<TagUploadData[]>([]);
  const { isAuthenticated } = useAuth();

  const refetchTagUploads = async () => {
    setSIsLoading(true);
    isLoading.current = true;
    const {errors, data} = await fetchData('/tags-uploads/all');
    setTagUploads(data ?? []);
    isLoading.current = false;
    setSIsLoading(false);
  }

  useEffect(() => {
    if (isAuthenticated && !isLoading.current) {
      refetchTagUploads();
    }
  }, [isAuthenticated]);

  const getRows = (tagUploads: TagUploadData[]) => {
    const result: TagUploadTableData[] = [];
    for (let i=0; i<tagUploads.length; i++) {
      result.push({
        id: `${tagUploads[i].id}`,
        filename: <Typography sx={{
                      margin: 0,
                      '& *': {
                        margin: 0,
                      }
                    }}
                  >
                    <span style={{fontSize: 18}}>{tagUploads[i].filename}</span>
                    <br/>
                    <span style={{fontSize: 15, fontStyle: 'italic'}}>{tagUploads[i].total} records</span>
                  </Typography>,
        date_imported: tagUploads[i].created_at,
        import_status: <Typography sx={{
                            margin: 0,
                            '& *': {
                              margin: 0,
                            },
                            '& .status.success': {
                              margin: 0,
                              color: '#009444'
                            },
                            '& .status.failed': {
                              margin: 0,
                              color: '#DA0101'
                            }
                          }}
                          dangerouslySetInnerHTML={{__html: tagUploads[i].description ?? ''}}>
                        </Typography>
      });
    }
    return result;
  }

  useEffect(() => {
    setRows(getRows(tagUploads));
  }, [tagUploads]);

  return (
    <Frame title="Upload Tags" toolbarButtons={(
      <> </>
    )}>
      <Stack spacing={6}>
        <UploadTagPanel refetchTagUploads={refetchTagUploads} />
        <Stack spacing={4}>
          <Typography fontFamily="korolev-condensed" variant="h4" fontWeight="600">Previous Uploads</Typography>
          <DataTable hideToolBar headCells={headCells} rows={rows} title="Clients" isLoading={sIsLoading} />
        </Stack>
      </Stack>
    </Frame>
  )
}
